import Enchante from '../../media/Enchante.png'
import Terravia from '../../media/Terravia.png'
import Hiera from '../../media/logo bsd (1).png'
import Tanakayu from '../../media/Tanakayu.png'

const clusterimages =[
Enchante,Terravia,Hiera,Tanakayu
]

export default clusterimages;